import { Avatar } from '../../@types';
import {
  AvatarDataType,
  axiosInstance,
  createFilteringSortingUrlParams,
  FilteringSortingParams,
} from '../../utils';

export interface FetchPrivateAvatarsResponse {
  data: AvatarDataType[];
  count: number;
}
export const fetchPrivateAvatars = async (
  params: FilteringSortingParams
): Promise<FetchPrivateAvatarsResponse> => {
  const searchParams = createFilteringSortingUrlParams(params);
  const res = await axiosInstance.get(`/api/avatars?${searchParams}`);
  return res.data;
};
